import axios from "axios";


export const API_BASE_URL = "https://khodiyarautomotiveglass.com/api"; // API base
export const PUBLIC_BASE_URL = "https://khodiyarautomotiveglass.com/"; // Public path


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;


// export const API_BASE_URL = "http://127.0.0.1:8000/api"; // API base
// export const PUBLIC_BASE_URL = "http://127.0.0.1:8000/"; // Public path
